/**
 * AlmadarPostWelcomeToAlmadarENPostPageView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait AlmadarPostWelcomeToAlmadarENPostPage
 */

import { useAlmadarPostWelcomeToAlmadarENPostPageLogic } from '@/hooks/traits/useAlmadarPostWelcomeToAlmadarENPostPageLogic';
import type { AlmadarPostWelcomeToAlmadarENPostPageConfig } from '@/hooks/traits/useAlmadarPostWelcomeToAlmadarENPostPageLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { AlmadarPostWelcomeToAlmadarENPostView as AlmadarPostWelcomeToAlmadarENPostViewEntity } from '@app/shared';
import { AlmadarPostWelcomeToAlmadarENPostFooterView } from '@/components/traits/AlmadarPostWelcomeToAlmadarENPostFooterView';
import { AlmadarPostWelcomeToAlmadarENPostHeaderView } from '@/components/traits/AlmadarPostWelcomeToAlmadarENPostHeaderView';
import { Stack } from '@almadar/ui/components';
import { Box } from '@almadar/ui/components';
import { Container } from '@almadar/ui/components';
import { AlmadarPostWelcomeToAlmadarENPostView } from '@/components/traits/AlmadarPostWelcomeToAlmadarENPostView';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface AlmadarPostWelcomeToAlmadarENPostPageViewProps {
  config?: Partial<AlmadarPostWelcomeToAlmadarENPostPageConfig>;
}

export function AlmadarPostWelcomeToAlmadarENPostPageView({ config: propsConfig }: AlmadarPostWelcomeToAlmadarENPostPageViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useAlmadarPostWelcomeToAlmadarENPostPageLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['AlmadarPostWelcomeToAlmadarENPostView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="AlmadarPostWelcomeToAlmadarEN" trait="AlmadarPostWelcomeToAlmadarENPostPage">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="AlmadarPostWelcomeToAlmadarENPostPage">{slotWriter['main'] === 'INIT' ? (<Stack gap="none" direction="vertical"><AlmadarPostWelcomeToAlmadarENPostHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><Box bg="transparent" fullWidth={true} paddingY="xl"><Container size="xl" maxWidth="xl" padding="lg"><AlmadarPostWelcomeToAlmadarENPostView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Container></Box><AlmadarPostWelcomeToAlmadarENPostFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default AlmadarPostWelcomeToAlmadarENPostPageView;
